/**
 * GLDN PLP Sidenav Toggle
 *
 * Interactive expand/collapse for the desktop categories sidebar
 * (ss-plp-navigation). Matches the legacy site, where clicking the
 * chevron OR the link text on an expandable branch toggles the menu
 * without navigating away. Non-expandable items (no chevron) navigate
 * as normal anchors.
 *
 * Initial open/closed state is rendered server-side by Liquid based on
 * the current collection; this script only handles user-driven toggling.
 */
(function () {
  /* Guard against double-registration. shopify theme dev hot-reload re-evaluates
   * the script after each edit; each evaluation closes over a fresh IIFE and
   * would attach another `click` listener to `document`, so a single click would
   * fire all N handlers in sequence — visible as multiple items toggling at the
   * same tick. The sentinel makes the IIFE idempotent. */
  if (window.__gldnPlpSidenavToggleInstalled) return;
  window.__gldnPlpSidenavToggleInstalled = true;

  function toggle(item, toggleButton) {
    var willOpen = !item.classList.contains('is-open');
    item.classList.toggle('is-open', willOpen);
    if (toggleButton) toggleButton.setAttribute('aria-expanded', String(willOpen));
  }

  document.addEventListener('click', function (e) {
    /* Chevron click: toggle the nearest item or subitem. */
    var toggleButton = e.target.closest('.ss-plp-navigation__toggle');
    if (toggleButton) {
      var hostFromToggle = toggleButton.closest('.ss-plp-navigation__subitem, .ss-plp-navigation__item');
      if (!hostFromToggle) return;
      e.preventDefault();
      toggle(hostFromToggle, toggleButton);
      return;
    }

    /* Modifier-key clicks (open in new tab, etc.) keep normal navigation. */
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;

    /* Link click on an expandable branch: also toggle, do not navigate.
     * The parent's `.is-expandable` class is the signal — non-expandable
     * items (no chevron) keep normal link behavior. Only intercept the
     * direct child link of the item, not links inside the submenu. */
    var link = e.target.closest('a');
    if (!link) return;
    var host = link.parentElement;
    if (!host) return;
    var isDirectExpandable =
      (host.classList.contains('ss-plp-navigation__item') ||
        host.classList.contains('ss-plp-navigation__subitem')) &&
      host.classList.contains('is-expandable');
    if (!isDirectExpandable) return;

    e.preventDefault();
    var innerToggle = host.querySelector(':scope > .ss-plp-navigation__toggle');
    toggle(host, innerToggle);
  });

  /* #320: publish the sidebar's rendered height so its sticky `top` in
   * gldn-global-overrides.css can pin the bottom edge when the menu is
   * taller than the viewport. Re-measures when an accordion opens or closes. */
  var nav = document.querySelector('.ss-plp-navigation');
  if (nav && 'ResizeObserver' in window) {
    new ResizeObserver(function () {
      nav.style.setProperty('--ss-plp-nav-height', nav.offsetHeight + 'px');
    }).observe(nav);
  }
})();
